export function getEmailDomainForAnalytics(email: string): string | undefined {
  const at = email.lastIndexOf('@');
  if (at <= 0 || at >= email.length - 1) {
    return undefined;
  }
  return email.slice(at + 1).toLowerCase();
}
